import { render, staticRenderFns } from "./BaseFadeTransition.vue?vue&type=template&id=d132b300&scoped=true&"
import script from "./BaseFadeTransition.vue?vue&type=script&lang=js&"
export * from "./BaseFadeTransition.vue?vue&type=script&lang=js&"
import style0 from "./BaseFadeTransition.vue?vue&type=style&index=0&id=d132b300&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../client_web_food_market/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d132b300",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Administrator\\Desktop\\gtzn\\FreeGoShop\\client_web_food_market\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('d132b300', component.options)
    } else {
      api.reload('d132b300', component.options)
    }
    module.hot.accept("./BaseFadeTransition.vue?vue&type=template&id=d132b300&scoped=true&", function () {
      api.rerender('d132b300', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "client_web_common/base_components/BaseFadeTransition.vue"
export default component.exports